import {Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {filter, flow, get, includes, map} from '@yandex-delivery/utils'
import {type FC, type ReactNode, Children} from 'react'
import {useFormContext} from 'react-hook-form'

import {AddressWidget, PickupWidget} from '../Address/desktop'
import {type AddressWidgetConfig, type SectionProps as Props, type WidgetConfig, WidgetType} from '../types'

export const Route: FC<Props> = flow(
  get('section.widgets'),
  filter((widget: WidgetConfig): widget is AddressWidgetConfig => widget.type === WidgetType.ADDRESS),
  map((widget: AddressWidgetConfig): ReactNode => {
    const name = widget.route_point_index === 0 ? 'source' : `destination_${widget.route_point_index}`
    const {watch} = useFormContext()

    const shouldShowPickupWidget = isPickupWidget(widget)
    // без этого условия при удалении адреса будем рисовать лишний пустой виджет,
    // пока не получим ответ бэка с верным количеством точек. Первые две точки рисуем безусловно
    const shouldShowWidget =
      ['source', 'destination_1'].includes(name) || watch(`route.${name}.address`) || shouldShowPickupWidget

    return (
      shouldShowWidget && (
        <Grid xs={12} item>
          <Paper padding="none" radius="L">
            {shouldShowPickupWidget ? <PickupWidget config={widget} /> : <AddressWidget config={widget} />}
          </Paper>
        </Grid>
      )
    )
  }),
  Children.toArray,
)
Route.displayName = 'RouteDesktop'

const isPickupWidget: (widget: AddressWidgetConfig) => boolean = flow(
  get('widget_id'), //
  includes('ndd'),
)
